import { createRouter, createWebHistory } from 'vue-router';

const passwordResetInit = () => import('@/venit/auth/auth-password-reset/auth-password-reset-init.vue');
const passwordResetFinish = () => import('@/venit/auth/auth-password-reset/auth-password-reset-finish.vue');
const accountActivate = () => import('@/venit/auth/auth-account-activate/auth-account-activate.vue');

const homePage = () => import('@/venit/app-home/app-home.vue');
const errorPage = () => import('@/core/error/error.vue');
const loginPage = () => import('@/venit/app-login/app-login.vue');
import admin from '@/router/route-admin';
import user from '@/router/route-user';

// prettier-ignore
export default createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'Home',
      component: homePage
    },
    {
      path: '/forbidden',
      name: 'Forbidden',
      component: errorPage,
      meta: { error403: true }
    },
    {
      path: '/not-found',
      name: 'NotFound',
      component: errorPage,
      meta: { error404: true }
    },
    {
      path: '/login',
      name: 'Login',
      component: loginPage,
    },
    {
      path: '/account/activate',
      name: 'accountActivate',
      component: accountActivate,
    },
    {
      path: '/password/reset/request',
      name: 'PasswordResetInit',
      component: passwordResetInit,
    },
    {
      path: '/account/password-reset',
      name: 'passwordResetFinish',
      component: passwordResetFinish,
    },
    ...admin,
    ...user,
  ]
});
